import React from 'react'
import moment from 'moment'
import { Text, Avatar, Pane, majorScale, Badge, minorScale } from 'evergreen-ui'
import ReactMarkdown from 'react-markdown'
import RouterAwareLink from 'components/RouterAwareLink'

export interface NotificationProps {
  action?: {
    url: string
  }
  actionable?: boolean
  category?: string
  content: string
  id: string
  initiator?: string
  insertedAt?: string
  read: boolean
  templateKey: string
  borderTop?: string
  onClick?: () => void
}

class Notification extends React.Component<NotificationProps> {
  static defaultProps = {
    action: null,
    actionable: false,
    read: false
  }

  render() {
    const { action, actionable, category, content, id, initiator, insertedAt, read, templateKey, ...props } = this.props

    const linkProps: any = {}

    if (action) {
      linkProps.display = 'block'
      linkProps.to = action.url
      linkProps.is = RouterAwareLink
      linkProps.openExternalInNewTab = true
    }

    return (
      <Pane
        position="relative"
        paddingY={majorScale(3)}
        paddingLeft={majorScale(3)}
        paddingRight={majorScale(1)}
        background={read ? 'white' : 'tint1'}
        {...linkProps}
        {...props}
      >
        <Pane is={ReactMarkdown} marginRight={majorScale(2)} marginBottom={majorScale(1)}>
          {content}
        </Pane>
        <Pane display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap">
          <Pane display="flex" alignItems="center" marginTop={majorScale(1)}>
            <Text color="muted" size={300}>
              {moment(insertedAt).calendar()}
            </Text>
            {initiator && initiator !== 'automatic' && (
              <Pane display="flex" alignItems="center">
                <Avatar isSolid marginX={majorScale(1)} name={initiator} size={majorScale(3)} />
                <Text color="muted" size={300} textTransform="capitalize">
                  {initiator}
                </Text>
              </Pane>
            )}
          </Pane>
          {category && (
            <Badge marginTop={majorScale(1)} marginX={minorScale(1)}>
              {category}
            </Badge>
          )}
        </Pane>
      </Pane>
    )
  }
}

export default Notification
